import { TableCell, TableRow, Typography } from '@mui/material';
import type { DescalceViewState } from './descalceViewState';

/**
 * Four distinct, named empty/error rows — never one generic "no data"
 * message. Rendered inside the table body (`<TableRow><TableCell
 * colSpan={…} align="center">`), same shape as `EconomicsPage`'s empty
 * state.
 */
export const DescalceEmptyState = ({
  state,
  colSpan
}: {
  state: Exclude<DescalceViewState, 'rows'>;
  colSpan: number;
}) => {
  const { text, color } = MESSAGES[state];
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" data-descalce-empty-state={state}>
        <Typography sx={{ fontSize: '0.82rem', color, py: 2 }}>{text}</Typography>
      </TableCell>
    </TableRow>
  );
};

const MESSAGES: Record<
  Exclude<DescalceViewState, 'rows'>,
  { text: string; color: string }
> = {
  loading: {
    text: 'Loading opener descalce snapshot…',
    color: 'grey.500'
  },
  'snapshot-unavailable': {
    text:
      'Snapshot unavailable — the descalce sweeper (manual-order-monitor) has ' +
      'not published a read yet, or its Redis key expired. It sweeps every ' +
      '~15s; this clears itself once the first sweep succeeds.',
    color: 'warning.main'
  },
  unconfigured: {
    text:
      'No venue credentials are configured for any of the venue-accounts in ' +
      'this snapshot — the sweeper has nothing to read.',
    color: 'warning.main'
  },
  error: {
    text: 'Failed to read the opener descalce snapshot.',
    color: 'error.main'
  },
  empty: {
    text: 'No open positions on any opener rule right now.',
    color: 'grey.500'
  }
};
